import React, { useContext } from 'react';
import LocaleContext from '../../../constants/localization';

const SaveCancelButton = ({ disabled, handleCancel }) => {
  const LS = useContext(LocaleContext);

  return (
    <div style={{ marginTop: '10px' }}>
      <button
        className="button"
        style={{ display: 'inline-block' }}
        type="submit"
        disabled={disabled}
      >
        {LS.manageGroups.save}
      </button>
      <button
        className="button cancel-button"
        style={{ display: 'inline-block' }}
        type="button"
        onClick={handleCancel}
      >
        {LS.manageGroups.cancel}
      </button>
    </div>
  );
};

export default SaveCancelButton;
